<template>
  <el-col
    class="cell-row"
    :span="cellSpan.main"
    :class="{ 'content-row-sub': subCell }"
  >
    <el-col :span="cellSpan.label">{{ label }}</el-col>
    <el-col v-if="!isImg" :span="cellSpan.value"
      >{{ cellValue }}
      <el-tooltip
        style="margin-left: 10px"
        v-if="isTooltip && value"
        :effect="effect"
        :content="tooltipContent"
        :placement="placement"
      >
        <i class="el-icon-question"></i> </el-tooltip
    ></el-col>
    <view v-else-if="isTime">{{ value | parseTime(timeFormat) }}</view>
    <el-col v-else class="row-img" :span="cellSpan.value">
      <el-image
        v-if="value"
        :src="value"
        :preview-src-list="imageList"
        fit="cover"
        class="row-img__item"
      />
      <div v-else>暂无</div>
    </el-col>
  </el-col>
</template>

<script>
import { thousandSymbol } from '@/filters'
export default {
  name: 'base-cell',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: null,
    numberFormat: {
      type: Boolean,
      default: false
    },
    valueUnit: {
      type: String,
      default: ''
    },
    subCell: {
      type: Boolean,
      default: false
    },
    allCell: {
      type: Boolean,
      default: false
    },
    isImg: {
      type: Boolean,
      default: false
    },
    isTime: {
      type: Boolean,
      default: false
    },
    timeFormat: {
      type: String,
      default: ''
    },
    isTooltip: {
      type: Boolean,
      default: false
    },
    effect: {
      type: String,
      default: 'dark'
    },
    tooltipContent: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'top'
    }
  },
  data() {
    return {}
  },
  computed: {
    cellValue() {
      if (this.value === null || this.value === '') return '暂无'
      if (this.value === undefined) return ''
      if (this.numberFormat) return thousandSymbol(this.value) + this.valueUnit
      return this.value + this.valueUnit
    },
    cellSpan() {
      return this.allCell
        ? { main: 24, label: 3, value: 9 }
        : { main: 12, label: 6, value: 18 }
    },
    imageList() {
      if (this.isImg) {
        return [this.value]
      }
      return []
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss">
.content-row-sub {
  padding-left: 10px;
  font-size: 13px;
  .el-col {
    color: #666;
  }
}

.cell-row {
  .row-img {
    &__item {
      width: 110px;
      height: 110px;
      object-fit: cover;
      border-radius: 8px;
      cursor: pointer;
    }
  }
}
</style>
